module.exports = __webpack_public_path__ + "img/ni.dafeb4e.svg";